<template>
   <div v-if="show">
      <div
        class="relative flex items-center gap-3 px-[12px] py-[12px] shadow-sm rounded-md w-[92vw] md:w-[335px]"
        :style="{
          backgroundColor: type === 'success' ? '#E6F9ED' : '#FCEDED',
          border: `1px solid ${type === 'success' ? '#407054' : '#A53535'}`,
          height: '51px'
        }"
      >
        <!-- Spike pointer -->
        <!-- Outer triangle (border) -->
  <div
    class="absolute -top-[8px] right-[8px] w-0 h-0 z-0"
    style="
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-bottom: 8px solid #407054;
    "
  ></div>
  
  <!-- Inner triangle (fills background color of toast) -->
  <div
    class="absolute -top-[6px] right-[9px] w-0 h-0 z-10"
    style="
      border-left: 7px solid transparent;
      border-right: 7px solid transparent;
      border-bottom: 7px solid #E6F9ED;
    "
  ></div>
  
  
        <!-- Icon Circle -->
        <div
          class="flex items-center justify-center h-5 w-5 rounded-full"
          :style="{ backgroundColor: type === 'success' ? '#407054' : '#A53535' }"
        >
          <svg
            class="w-3 h-3 text-white"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="3"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              :d="
                type === 'success'
                  ? 'M5 13l4 4L19 7'
                  : 'M6 18L18 6M6 6l12 12'
              "
            />
          </svg>
        </div>
  
        <!-- Message -->
        <p
          class="text-sm font-medium"
          :style="{ color: type === 'success' ? '#181818' : '#7A1E1E' }"
        >
          {{ message }}
        </p>
  
        <!-- Close button -->
        <button
          class="absolute right-[16px] top-[16px]"
          :style="{ color: type === 'success' ? '#181818' : '#7A1E1E' }"
          @click="close"
        >
          <svg
            class="w-[16px] h-[16px]"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { useAddToCartToastStore } from '~/stores/addToCartToastStore'

const toastStore = useAddToCartToastStore()

const { show, type, message } = storeToRefs(toastStore)

function close() {
  toastStore.close()
}
</script>
